import { ITireDTO } from 'app/shared/model/dto/tire-dto.model';
import React from 'react';
import TireImg from './tire-img';
import { renderState } from './tire-status';
import { Box, Grid, Typography } from '@mui/material';

interface Props {
  tire: ITireDTO;
  position?: number;
  steppe?: boolean;
}

export const TireDetail = (props: Props) => {
  const { tire, position, steppe } = props;

  return (
    <Box>
      {tire && (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 3 }}>
          <TireImg position={position} steppe={steppe} />
          <Grid container spacing={1} sx={{ ml: 3 }}>
            <Grid item xs={6}>
              <Typography variant="h5" sx={{ pr: 3 }}>
                {tire?.state && renderState(tire?.state)}
              </Typography>
            </Grid>
            <Grid item xs={6} />

            <Grid item xs={6}>
              <Typography sx={{ pr: 3 }}>Marca</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: 'bold' }}>{tire?.tireModel?.tireManufacturer?.name}</Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography sx={{ pr: 3 }}>Modelo</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: 'bold' }}>{tire?.tireModel?.name}</Typography>
            </Grid>

            {(tire?.totalRecaps ?? 0) > 0 && (
              <>
                <Grid item xs={6}>
                  <Typography sx={{ pr: 3 }}>Recapagem</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: 'bold' }}>{tire?.totalRecaps}</Typography>
                </Grid>
              </>
            )}

            {tire?.marking && (
              <>
                <Grid item xs={6}>
                  <Typography sx={{ pr: 3 }}>Pneu</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: 'bold' }}>{tire?.marking}</Typography>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default TireDetail;
